import React from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { WhySection } from "@/components/WhySection";
import { Experiences } from "@/components/Experiences";
import { HowItWorks } from "@/components/HowItWorks";
import { Standard } from "@/components/Standard";
import { Marquee } from "@/components/Marquee";
import { Gallery } from "@/components/Gallery";
import { Reviews } from "@/components/Reviews";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { BookingFlow } from "@/components/BookingFlow";

export default function Landing() {
  return (
    <div className="bg-warmwhite" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <WhySection />
        <Experiences />
        <HowItWorks />
        <Standard />
        <Marquee />
        <Gallery />
        <Reviews />
        <FinalCTA />
      </main>
      <Footer />
      <BookingFlow />
    </div>
  );
}
